export class LoyaltyCardUserSearchModel {
  public search: string;
  public cardId: string;
}
